export default "__VITE_ASSET__l8St8O0T__"